<div id="step1_selectTrigger" class="collapse" style="clear: both; display: block;">
		
	<!-- Title -->
	<h1 style="color:#f57300; font-size: 50px">
		<i class="fa fa-bolt" aria-hidden="true"></i>
		STEP 1: SELECT THE TRIGGER
	</h1>
	
	<!-- Instructions -->
	<p style="color: #ffffff; font-size: 18px">
		Select one trigger. The trigger is what will set off this rule.
	</p>
	
	<div style="color: #ffffff; margin: 20px 20px 20px 0">
		<!-- Event already selected... Display the selected Event with an option to unselect it -->
		<ng-container *ngIf="mRule.event != null">
			<div>
				<div class="col-sm-3">
					<div class="panel panel-drk-ornge">
						<div class="panel-body" style="height: 190px; overflow: hidden; max-height: 100%">
							<i class="fa fa-4x fa-4x {{getGlpyhForEvent(mRule.event)}}" aria-hidden="true" style="color: #f57300"></i>
							<h3 style="overflow: hidden">{{mRule.event.name}}</h3>
							<h4 style="overflow: hidden">{{mRule.event.description}}</h4>
						</div>
						<div class="panel-footer panel-drk-ornge">
							<button (click)="selectEvent(null); mEventsPageNumber = 1;" class="btn btn-ef" style="width: 100%" >REMOVE</button>
						</div>
					</div>
				</div>
			</div>
		</ng-container>
		
		<!-- No Event Selected... Display the Events which can be selected -->
		<ng-container *ngIf="mRule.event == null">
			<!-- Search -->
			<div class="input-group" style="padding-bottom:20px; max-width:100%">
				<input [(ngModel)]="mEventsSearchValue" type="text" class="form-control input-lg" placeholder="Search For a Trigger..." (keyup)="refreshEventsCarouselPages()">
				<div class="input-group-btn">
					<button (click)="refreshEventsCarouselPages()" type="button" style="height: 46px" class="btn btn-ef btn-lg" tabindex="-1">
						<span class="glyphicon glyphicon-search"></span>
					</button>
				</div>
			</div>
			
			<h4>POPULAR TRIGGERS</h4>
			
			<!-- Carousel -->
			<div id="eventCarousel" class="carousel slide">
				
				<!-- Carousel Items/Pages -->
				<div class="carousel-inner">
					<ng-container *ngFor="let page of mEventCarouselPages">
						<div [class.active]="page == mEventCarouselPages[0]" class="item">
							<div class="row">
								<ng-container *ngFor="let event of page.mEvents">
									<div>
										<div class="col-sm-3">
											<div class="panel panel-drk-ornge">
												<div class="panel-body" style="height: 190px; overflow: hidden; max-height: 100%">
													<i class="fa fa-4x fa-4x {{getGlpyhForEvent(event)}}" aria-hidden="true" style="color: #f57300"></i>
													<h3 style="overflow: hidden">{{event.name}}</h3>
													<h4 style="overflow: hidden">{{event.description}}</h4>
												</div>
												<div class="panel-footer panel-drk-ornge">
													<button (click)="selectEvent(event)" class="btn btn-ef" style="width: 100%" >SELECT</button>
												</div>
											</div>
										</div>
									</div>
								</ng-container>
							</div>
						</div>
					</ng-container>
				</div>
			</div>
			
			<!-- Carousel Navigation Links -->
			<ol id="eventCarouselPaging" class="eventCarousel carousel-linked-nav pagination" style="margin-top: 10px; margin-bottom: 20px">
					<li *ngFor="let page of mEventCarouselPages" [class.active]="mEventsPageNumber == page.mId" (click)="setEventsPageNumber(page.mId)" data-target="#eventCarousel" [attr.data-slide-to]="page.mId - 1">
						<a>{{page.mId}}</a>
					<li>
			</ol>
		</ng-container>
	</div>
	
</div>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>